import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ZvlnabidkaId: null as number | null,
	ZvlnabidkaOzn: null as string | null,
	Text: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	ShortlistPrp: true,
	ZvlnabidkaPzn: null as number | null,
	Banner: null as string | null,
	PcPevna: null as number | null,
	VyrobekvozOzn: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ZvlnabidkaPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
